"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CollaboratorsModule = /** @class */ (function () {
    function CollaboratorsModule() {
    }
    return CollaboratorsModule;
}());
exports.CollaboratorsModule = CollaboratorsModule;
